import { faExclamationCircle, faCheckCircle } from '@fortawesome/free-solid-svg-icons';

// Define the Urgency enum for outcome tasks
export const UrgencyEnum = {
  URGENT: {
    value: "URGENT",
    displayName: "URGENT",
    description: "Urgent",
    color: "rgb(255, 215, 196)",
    colorFamily: 'amber',
    icon: faExclamationCircle
  },
  NORMAL: {
    value: "NORMAL",
    displayName: "NORMAL",
    description: "Normal",
    color: "rgb(196, 255, 211)",
    colorFamily: 'green',
    icon: faCheckCircle
  }
};

// Helper function to get urgency from isUrgent boolean
export const getUrgency = (isUrgent) => {
  return isUrgent ? UrgencyEnum.URGENT : UrgencyEnum.NORMAL;
};
